import PulseAppProviders from "@pulse/PulseAppProviders";
import { loadSurveyParticipant } from "@pulse/features/SurveyResponse/loadSurveyParticipant";
import SurveyResponsePage from "@pulse/features/SurveyResponse/SurveyResponsePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/pulse/surveys/$participantId")({
    component: RouteComponent,
    loader: (ctx) => loadSurveyParticipant(String(ctx.params.participantId)),
    staticData: {
        titleFn: null,
    },
});

function RouteComponent() {
    return (
        <PulseAppProviders>
            <div className="pulse-theme">
                <main className="h-full min-h-screen w-full overflow-auto" id="main-area">
                    <SurveyResponsePage />
                </main>
            </div>
        </PulseAppProviders>
    );
}
